import React from 'react';
import { useReadingPreferences } from '../../context/ReadingPreferencesContext';
import { Icon } from './Icon';

interface FontSizeControlProps {
  /** 'md' for the desktop header (h-8 w-8). 'sm' for the mobile reading bar (h-10 w-10). */
  size?: 'sm' | 'md';
}

export const FontSizeControl: React.FC<FontSizeControlProps> = ({ size = 'md' }) => {
  const { increaseFontSize, decreaseFontSize, canIncrease, canDecrease } = useReadingPreferences();

  const btnBase =
    'inline-flex items-center justify-center rounded-lg border border-border bg-background ' +
    'transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary';
  const btnEnabled = 'hover:bg-muted text-muted-foreground hover:text-foreground';
  const btnDisabled = 'opacity-40 cursor-not-allowed text-muted-foreground';
  const btnSize = size === 'sm' ? 'h-10 w-10' : 'h-8 w-8';
  const iconSize = size === 'sm' ? 18 : 16;

  return (
    <div className="flex items-center gap-1" role="group" aria-label="Font size">
      <button
        onClick={canDecrease ? decreaseFontSize : undefined}
        disabled={!canDecrease}
        aria-label="Decrease font size"
        aria-disabled={!canDecrease}
        title="Decrease font size"
        className={`${btnBase} ${btnSize} ${canDecrease ? btnEnabled : btnDisabled}`}
      >
        <Icon name="a-arrow-down" size={iconSize} aria-hidden="true" />
      </button>

      <button
        onClick={canIncrease ? increaseFontSize : undefined}
        disabled={!canIncrease}
        aria-label="Increase font size"
        aria-disabled={!canIncrease}
        title="Increase font size"
        className={`${btnBase} ${btnSize} ${canIncrease ? btnEnabled : btnDisabled}`}
      >
        <Icon name="a-arrow-up" size={iconSize} aria-hidden="true" />
      </button>
    </div>
  );
};
